import React, {useEffect, useState} from 'react';
import Swal from 'sweetalert2';
import {t} from 'react-switch-lang';
import {Edit} from '../../../components/modals/ModalEdit';
import {Delete} from '../../../components/modals/ModalDelete';
import {searchExternalizationTemplates} from '../../../utils/externalizationFormOptions';
import {Show} from '../../../components/modals/ModalShow';
import SearchHeader from '../department/pageHeader/PageHeader';
import {Add} from '../../../components/modals/ModalAdd';
import Loader from '../../../components/loader/Loader';
import TableAdministration from '../../../components/tablesAdministration/Table-administration';
import {getAllServiceProviders} from '../../../services/externalizations/serviceProvidersService';

const ServiceProviders = () => {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [filterItems, setFilterItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState('');
  const [rowChanged, setRowChanged] = useState(false);
  const [search, setSearch] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const fetchData = () => {
    setIsLoading(true);
    setIsLoadingPage(true);
    setPage(0);
    setHasMore(true);
    getAllServiceProviders(page)
      .then((r) => {
        setItems(generateRows(r?.data));
        setFilterItems(generateRows(r?.data));
        setIsLoading(false);
        setIsLoadingPage(false);
      })
      .catch((r) => {
        setIsLoading(false);
        setIsLoadingPage(false);
        if (r.message === 'Network Error') {
          Swal.fire({
            text: `${t('message.errorServerTitle')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            text: `${t('message.errorApi')}`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });
  };
  const generateRows = (items) => {
    return items.map(item => {
        return {
          name: item?.name,
          tin: item?.tin,
          onClick: () => onRowClick(item),
          buttons: [
            <Edit data={item} id='serviceProviders'
                  setRowChanged={() => onRowChange()} fetchData={() => fetchData()} />
            ,
            <Delete
              data={item}
              id='serviceProviders'
              setRowChanged={() => onRowChange()}
            />,

          ],
        };
      },
    );
  };
  const filterList = (event) => {
    const search = event.target.value;
    setSearch(search);
    setFilterItems(searchExternalizationTemplates(search, items));
  };
  useEffect(() => {
    fetchData();
  }, [rowChanged]);

  const onRowClick = (item) => {
    setModalData(item);
    setModal(!modal + 1);
  };

  const onRowChange = () => {
    setRowChanged(!rowChanged);
    setSearch('');
    setTableKey(tableKey + 1);
  };
  const tableHeader = [
    t('externalization.riskProponentForm.serviceProvider'),
    t('externalization.tin')
  ];
  const loadMoreItems = async () => {
    const res = await getAllServiceProviders(page);

    if (res?.data?.length === 0) {
      setHasMore(false);
      return;
    }

    setItems(prev => [...prev, ...generateRows(res?.data)]);
    setPage(prev => prev + 1);
  };
  return (
    <div style={{padding: '0 30px'}} className=' h-100  pb-3'>
      <Show
        data={modalData}
        id='serviceProviders'
        type='serviceProviders'
        modal={modal}
        setModal={setModal}
        isEditable={true}
        setRowChanged={() => onRowChange()}
        fetchData={() => fetchData()}
      />
      <SearchHeader
        placeholder={t('externalization.placeholder.searchServiceProviders')}
        button={
          <Add id='serviceProviders' setRowChanged={() => onRowChange()} />
        }
        onChange={(e) => filterList(e)}
        showInput={true}
        showButton={true}
      />
      <div
        className='position-relative administration-page-table-container pt-4'>
        {isLoadingPage && <Loader zIndex={'1'} />}
        <TableAdministration
          key={tableKey}
          tableHeader={tableHeader}
          tableRows={search ? filterItems : items}
          fetchMoreData={!search ? loadMoreItems : undefined}
          hasMore={hasMore}
          isLoading={isLoading}
          editableRow={false}
        />
      </div>
    </div>
  );
};

export default ServiceProviders;